import {
  applyMiddleware,
  compose,
  createStore as createReduxStore
} from 'redux'
import { hashHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
import createSagaMiddleware from 'redux-saga'
// import LogRocket from 'logrocket'
import { persistStore, autoRehydrate } from 'redux-persist'
import { REHYDRATE } from 'redux-persist/constants'
import createActionBuffer from 'redux-action-buffer'

import makeRootReducer from './reducers'
import makeRootSaga from './sagas'
import { updateLocation } from './location'

// const __DEV__ = process.env.NODE_ENV === 'development'

const createStore = (initialState = {}) => {
  return new Promise((resolve, reject) => {
    try {
      // ======================================================
      // Middleware Configuration
      // ======================================================
      const sagaMiddleware = createSagaMiddleware()
      const middleware = [
        sagaMiddleware,
        routerMiddleware(hashHistory),
        createActionBuffer(REHYDRATE)
        // LogRocket.reduxMiddleware()
      ]

      // ======================================================
      // Store Enhancers
      // ======================================================
      const enhancers = [autoRehydrate()]
      let composeEnhancers = compose

      if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      }

      // ======================================================
      // Store Instantiation and HMR Setup
      // ======================================================
      const store = createReduxStore(
        makeRootReducer(),
        initialState,
        composeEnhancers(applyMiddleware(...middleware), ...enhancers)
      )

      store.asyncReducers = {}
      store.asyncSagas = {}
      store.rootSaga = []

      store.runSaga = saga => sagaMiddleware.run(saga)

      store.runSaga(makeRootSaga(store))

      // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
      store.unsubscribeHistory = hashHistory.listen(updateLocation(store))

      if (module.hot) {
        module.hot.accept('./reducers', () => {
          const reducers = require('./reducers').default
          store.replaceReducer(reducers(store.asyncReducers))
        })

        module.hot.accept('./sagas', () => {
          const sagas = require('./sagas').default
          store.runSaga(sagas(store))
        })
      }

      persistStore(
        store,
        {
          whitelist: ['theme', 'authentication']
        },
        () => resolve(store)
      )
    } catch (error) {
      reject(error)
    }
  })
}

export default createStore



// WEBPACK FOOTER //
// ./src/store/createStore.js